import { render } from "./FloatingCartPill.vue?vue&type=template&id=4d7b861f&scoped=true"
import script from "./FloatingCartPill.vue?vue&type=script&lang=js"
export * from "./FloatingCartPill.vue?vue&type=script&lang=js"

import "./FloatingCartPill.vue?vue&type=style&index=0&id=4d7b861f&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7b861f"]])

export default __exports__